import { styled } from 'styled-components';

export const StyledTile = styled.div`
  width: ${({ $width }) => $width || '100%'};
  max-width: ${({ $maxWidth }) => $maxWidth || '100%'};
  min-height: ${({ $minHeight }) => $minHeight || 'auto'};
  margin: ${({ $margin }) => $margin || '0 0 1.25rem 0'};
  padding: ${({ $padding }) => $padding || '0'};
  color: ${({ theme }) => theme.colours.ink.primary.main};
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  border: ${({ $border, theme }) =>
    `${$border} solid ${theme.colours.canvas.primary.main}` || '0'};
  opacity: ${({ $opacity }) => $opacity};
  /* transition: opacity 0.3s ease;
  will-change: opacity;
  backface-visibility: hidden; */

  &.full {
    min-height: calc(100vh - 80px);
  }
`;
StyledTile.displayName = 'StyledTile';

export const StyledTileHeader = styled.div`
  position: relative;
  padding: ${({ $isSlim }) => ($isSlim ? '0.5rem' : '1rem')};
  padding-bottom: ${({ $noBottomPadding }) => $noBottomPadding && 0};
  min-height: 40px;
  margin-bottom: 0;
  box-shadow: none;
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  position: relative;
  border-bottom: ${({ $border, theme }) =>
    `${$border} solid ${theme.colours.canvas.secondary.main}` || '0'};
  font-size: ${({ theme }) => theme.typography.bodyRegular.fontSize};

  h1,
  h2,
  h3 {
    ${({ theme }) => theme.typography.headingMedium}
    margin: 0;
  }

  h2 {
    font-size: ${({ $isSlim, theme }) =>
      $isSlim && theme.typography.bodyRegular.fontSize};
  }

  h3 {
    line-height: 1.6;
  }

  .buttons {
    display: flex;
    position: absolute;
    top: ${({ $isSlim }) => ($isSlim ? '0.5rem' : '1rem')};
    right: ${({ $isSlim }) => ($isSlim ? '0.5rem' : '1rem')};
    gap: ${({ theme }) => theme.sizing.small};
    height: 24px;

    .ui.button.clear {
      border: 0;

      .icon {
        font-size: ${({ theme }) => theme.typography.headingLarge.fontSize};
      }
    }

    .ui.dropdown {
      svg {
        fill: ${({ theme }) => theme.colours.canvas.primary.ink} !important;
      }
    }

    .svg-fill,
    svg {
      fill: inherit;
    }
  }
`;
StyledTileHeader.displayName = 'StyledTileHeader';

export const StyledTileBody = styled.div`
  position: relative;
  padding: ${({ $padding }) => $padding || '1rem'};
  margin: ${({ $margin }) => $margin || '0'};
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  gap: ${({ $gap }) => $gap || '1rem'};
  min-height: ${({ $minHeight }) => $minHeight || 'auto'};
  max-height: ${({ $maxHeight }) => $maxHeight || 'auto'};
  overflow-y: ${({ $overflowY }) => $overflowY || 'visible'};
  font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};

  &.row {
    flex-direction: row;

    .ui.labeled.icon.button,
    .ui.labeled.icon.buttons .button {
      padding-left: 3.4em !important;
      padding-right: 1em !important;
    }
  }

  table {
    td {
      white-space: break-spaces;
      line-height: normal;
      font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
    }
  }

  .text-left {
    text-align: left;
  }

  .text-right {
    text-align: right;
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colours.layering[1].strong} !important;
  }

  .ui {
    &.small.text.loader {
      padding: 0 0 0 ${({ theme }) => theme.sizing.large};
      line-height: 1.7;
      width: 1rem;
      height: 1rem;
      z-index: 50;

      &:before,
      &:after {
        left: 0.625rem;
        top: 0.1875rem;
      }
    }
  }
`;
StyledTileBody.displayName = 'StyledTileBody';

export const StyledTileAccordionHeader = styled.div`
  box-shadow: none;
  margin: 0;
  font-size: ${({ theme }) => theme.typography.bodyRegular.fontSize};
  padding: 0 ${({ theme }) => theme.sizing.medium};
  min-height: 48px;
  line-height: 48px;
  color: ${({ theme }) => theme.colours.ink.primary.main};
  background-color: ${({ theme }) => theme.colours.canvas.secondary.main};

  &:hover {
    background-color: ${({ theme }) => theme.colours.canvas.secondary.strong};
  }

  + div {
    box-shadow: none;
    background: ${({ theme }) => theme.colours.canvas.tertiary.main};
  }
`;
StyledTileAccordionHeader.displayName = 'StyledTileAccordionHeader';

export const StyledTileAccordionBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap || '1rem'};
  box-shadow: none;
  margin: 0;
  font-size: ${({ theme }) => theme.typography.bodyRegular.fontSize};
  padding: ${({ $padding }) => $padding || '1rem'};
  border-bottom: 0;
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  color: ${({ theme }) => theme.colours.ink.primary.main};

  .table {
    tr {
      td {
        font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
      }
    }
  }
`;
StyledTileAccordionBody.displayName = 'StyledTileAccordionBody';
